@if (HasRequiredPermissions) {
@if (EntityInstance || isNew()) {
<!-- Conteneur principal avec layout flexbox -->
<div [fieldContext]="this" class="flex flex-col h-full">
  <!-- Titre fixe en dehors de la zone de défilement -->
  <div class="px-6 pt-4 pb-2">
    <h4 class="text-[0.9em] font-medium text-gray-500 z-[999]">
      @if (isNew()) {
      {{ 'entities.pointOfService.newEntity' | translate }}
      } @else {
      {{ 'entities.pointOfService.detailEntity' | translate }}
      }
    </h4>
    <div class="flex justify-between items-center">
      <button (click)="cancelEdit()"
        class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
  <!-- Zone de contenu avec défilement -->
  <div #scrollContainer class="{{Skin.detailContainer}} flex-1 overflow-auto">
    <!--  Conteneur desactivable -->
    <div class="{{this.UpdateMode}}">
      <!-- Section 0 : General Settings -->
      <div class="mb-0">
        <h2 class="text-base font-semibold text-gray-700 mb-0 border-b-2 border-black pb-2 mb-4">
          <i class="far fa-building mr-2"></i>{{'vues.pointOfService.detail.sections.generalSettings'|translate}}
        </h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-0">
          <!-- Colonne 1 -->
          <div class="space-y-0">
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="far fa-building mr-2"></i> Site Info
              </h4>
              <div class="flex justify-center mt-10 -mb-10 -ml-10">
                <div class="relative m-6 w-[140px] h-[150px] -mt-6 ml-16 border border-gray-300 overflow-hidden">
                  <i class="far fa-building absolute inset-0 text-gray-400 text-[150px] flex items-center justify-center pointer-events-none"
                    [ngClass]="{'hidden': imageUrl}"></i>
                  <img [src]="imageUrl || ''" class="w-full h-full object-cover" [ngClass]="{'hidden': !imageUrl}" />
                  <div class="absolute bottom-0 left-0 flex">
                    <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event,'FK_Image_Logo')" class="hidden" />
                    <button type="button" (click)="fileInput.click()"
                      class="bg-teal-500 hover:bg-teal-800 text-white px-2 py-1 text-xs font-xs">
                      <i class="fa fa-camera text-[0.9rem]"></i>
                    </button>
                    <button type="button" (click)="resetImage()" class="{{Skin.btnAlert}} px-2 py-1 text-xs font-xs">
                      <i class="fas fa-times text-[0.9rem]"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="space-y-4">

                <!-- Name -->
                <app-field-wrapper property="name">
                  <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'name')"
                    class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('name')">
                </app-field-wrapper>

                <!-- Custom URL -->
                <div>
                  <label class="{{Skin.upperCaseSmallLabel}}">
                    {{
                    'entities.pointOfService.propreties.prefix' | translate
                    }}
                  </label>


                  @if (!isEditMode()) {
                  <a class="text-[#009F9E] hover:underline block text-xs" target="_blank"
                    href="https://{{editingEntity()?.prefix}}.{{matwinsVariables.domainMatwins}}">
                    https://{{editingEntity()?.prefix}}.{{matwinsVariables.domainMatwins}}
                  </a>

                  } @else {
                  <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'prefix')"
                    class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('prefix')">
                  @if (hasValidationErrors('prefix')) {
                  <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
                    @for (error of getValidationErrors('prefix'); track error) {
                    <div>{{ error | translate }}</div>
                    }
                  </div>
                  }
                  }
                </div>

                <!-- Default Language -->
                <app-field-wrapper property="fK_i18nLanguage">
                  <select class="{{Skin.formInputSmallSize}}" required onReady
                    (autoBind)="bindingHandler($event, 'fK_i18nLanguage')"
                    [class.border-red-500]="hasValidationErrors('fK_i18nLanguage')">
                    <option [value]="null" disabled>{{ 'Choose a language' | translate }}</option> <!-- Placeholder -->
                    @for (languageOption of languageLookup(); track languageOption.key) {
                    <option [value]="languageOption.key">{{ `languages.${languageOption.value}` | translate }}</option>
                    }
                  </select>
                </app-field-wrapper>

                <!-- SMS Provider -->
                <app-field-wrapper property="smsProvider">
                  <select class="{{Skin.formInputSmallSize}}" required onReady
                    (autoBind)="bindingHandler($event, 'smsProvider')"
                    [class.border-red-500]="hasValidationErrors('smsProvider')">
                    @for (provider of smsProviderOptions(); track provider.key) {
                      <option [value]="provider.key">{{ provider.value }}</option>
                    }
                  </select>
                </app-field-wrapper>

                <!-- Time Zone -->
                <app-field-wrapper property="timeZone">
                  <select class="{{Skin.formInputSmallSize}}" required onReady
                    (autoBind)="bindingHandler($event, 'timeZone')"
                    [class.border-red-500]="hasValidationErrors('timeZone')">
                    @for (tz of timeZoneOptions; track tz.key) {
                    <option [value]="tz.key">{{ tz.label }}</option>
                    }
                  </select>
                </app-field-wrapper>
                <!-- Default Site -->
                <app-field-wrapper property="defaultPOS">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'defaultPOS')">
                </app-field-wrapper>
              </div>
            </div>
          </div>
          <!-- Colonne 2 -->
          <div class="space-y-0">
            <!-- Email Settings Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-envelope mr-2"></i> {{'vues.pointOfService.detail.sections.emailSettings'|translate}}
                <button class="text-[#009F9E] ml-2 open-modal" data-modal="modal-email">
                  <i class="fas fa-pencil text-xs"></i>
                </button>
              </h4>
            </div>

            <!-- Wifi Connection Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-wifi mr-2"></i> {{'vues.pointOfService.detail.sections.wifiConnection'|translate}}
                <button class="text-[#009F9E] ml-2 open-modal" data-modal="modal-wifi">
                  <i class="fas fa-pencil text-xs"></i>
                </button>
              </h4>
            </div>

            <!-- Address Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-map-marker-alt mr-2"></i> {{'vues.pointOfService.detail.sections.address'|translate}}
                <button class="text-[#009F9E] ml-2 open-modal" data-modal="modal-address">
                  <i class="fas fa-pencil text-xs"></i>
                </button>
              </h4>
            </div>

            <!-- Services Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-first-aid mr-2"></i> {{'vues.pointOfService.detail.sections.services'|translate}}
              </h4>

              <div class="space-y-3">
                <app-field-wrapper property="serviceUnavailable" label="vues.pointOfService.detail.sections.disableServices">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'serviceUnavailable')">
                </app-field-wrapper>
              </div>
            </div>

            <!-- Integration Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-sitemap mr-2"></i> Integration
                <button class="text-[#009F9E] ml-2 open-modal" data-modal="modal-integration">
                  <i class="fas fa-pencil text-xs"></i>
                </button>
              </h4>
            </div>
          </div>
        </div>
      </div>
      <!-- Section 1: Visitor Settings -->
      <div class="mb-0">
        <h2 class="text-base font-semibold text-gray-700 mb-0 border-b-2 border-black pb-2 mb-4">
          <i class="far fa-building mr-2"></i>{{'vues.pointOfService.detail.sections.visitorSettings'|translate}}
        </h2>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-0">
          <!-- Colonne 1 -->
          <div class="space-y-0">
            <!-- Site Info Card -->

            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="far fa-building mr-2"></i> Site Info
              </h4>
              <div class="space-y-4">

                <!-- Visitor History (Days) -->
                <app-field-wrapper property="visitorHistoryDays">
                  <input type="number" autocomplete="off" onReady
                    (autoBind)="bindingHandler($event, 'visitorHistoryDays')" class="{{Skin.formInputSmallSize}}"
                    [class.border-red-500]="hasValidationErrors('visitorHistoryDays')">
                </app-field-wrapper>

                <!-- Visitor Automatic Check Out -->
                <app-field-wrapper property="automaticCheckOut">
                  <select class="{{Skin.formInputSmallSize}}" required onReady
                    (autoBind)="bindingHandler($event, 'automaticCheckOut')"
                    (change)="onAutomaticCheckOutChange($event)"
                    [class.border-red-500]="hasValidationErrors('automaticCheckOut')">
                    <option value="0">None</option>
                    <option value="1">Fixed Hour</option>
                    <option value="2">Sliding</option>
                  </select>
                </app-field-wrapper>

                <!-- Hours after Check In -->
                <app-field-wrapper property="automaticCheckOutHour" *ngIf="isAutomaticCheckoutEnabled">
                  <input type="number" autocomplete="off" onReady [required]="isAutomaticCheckoutEnabled"
                    (autoBind)="bindingHandler($event, 'automaticCheckOutHour')" class="{{Skin.formInputSmallSize}}"
                    [class.border-red-500]="hasValidationErrors('automaticCheckOutHour')">
                </app-field-wrapper>

                <!-- Sending Reports Hour -->
                <app-field-wrapper property="reportStartHour">
                  <select class="{{Skin.formInputSmallSize}}" required onReady
                    (autoBind)="bindingHandler($event, 'reportStartHour')"
                    [class.border-red-500]="hasValidationErrors('reportStartHour')">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                  </select>
                </app-field-wrapper>



                <!-- Automatic Assign Access Card -->
                <app-field-wrapper property="automaticAssignAccessCard">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'automaticAssignAccessCard')">
                </app-field-wrapper>

                <!-- Notification Time Out (seconds) -->
                <app-field-wrapper property="notificationTimeOut">
                  <input type="number" autocomplete="off" onReady
                    (autoBind)="bindingHandler($event, 'notificationTimeOut')" class="{{Skin.formInputSmallSize}}"
                    [class.border-red-500]="hasValidationErrors('notificationTimeOut')">
                </app-field-wrapper>

                <!-- Notification Size -->
                <app-field-wrapper property="notificationSize">
                  <select class="{{Skin.formInputSmallSize}}" required onReady
                    (autoBind)="bindingHandler($event, 'notificationSize')"
                    [class.border-red-500]="hasValidationErrors('notificationSize')">
                    <option value="1">Medium</option>
                    <option value="2">Large</option>
                    <option value="3">Extra Large</option>
                  </select>
                </app-field-wrapper>

                <!-- Refresh Time (min) -->
                <app-field-wrapper property="dS_RefreshTime">
                  <input type="number" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'dS_RefreshTime')"
                    class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('dS_RefreshTime')">
                </app-field-wrapper>
              </div>
            </div>



            <!-- QR Code Visitor Settings Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-qrcode mr-2"></i> {{'vues.pointOfService.detail.sections.qRCodeSettings'|translate}}
                <button class="text-[#009F9E] ml-2 open-modal" data-modal="modal-qrcodes-visitor">
                  <i class="fas fa-pencil text-xs"></i>
                </button>
              </h4>


            </div>

            <!-- Printer Settings Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-print mr-2"></i> {{'vues.pointOfService.detail.sections.printerSettings'|translate}}
                <button class="text-[#009F9E] ml-2 open-modal" data-modal="modal-printer">
                  <i class="fas fa-pencil text-xs"></i>
                </button>
              </h4>
            </div>

            <!-- New Visitor Process Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-sitemap mr-2"></i> {{'vues.pointOfService.detail.sections.newVisitorProcess'|translate}}
              </h4>

              <div class="space-y-3">
                <app-field-wrapper property="dS_NewVisitor_MultipleHost">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewVisitor_MultipleHost')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewVisitor_Camera">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewVisitor_Camera')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewVisitor_Covid">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewVisitor_Covid')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewVisitor_Signature">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewVisitor_Signature')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_Visitor_Quiz">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Visitor_Quiz')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewVisitor_CompanyRequired">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewVisitor_CompanyRequired')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewVisitor_ShowPhoneNumber">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewVisitor_ShowPhoneNumber')">
                </app-field-wrapper>
              </div>
            </div>

            <!-- Returning Visitor Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-sitemap mr-2"></i> {{'vues.pointOfService.detail.sections.returningVisitor'|translate}}
              </h4>

              <div class="space-y-3">
                <app-field-wrapper property="dS_Visitor_Skip_Signature">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Visitor_Skip_Signature')">
                </app-field-wrapper>
              </div>
            </div>

            <!-- New Employee Process Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-sitemap mr-2"></i> {{'vues.pointOfService.detail.sections.newEmployeeProcess'|translate}}
              </h4>

              <div class="space-y-3">
                <app-field-wrapper property="dS_NewEmployee_Notify_Manager">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewEmployee_Notify_Manager')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewEmployee_Camera">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewEmployee_Camera')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewEmployee_QrCode">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewEmployee_QrCode')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewEmployee_Covid">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewEmployee_Covid')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewEmployee_Signature">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewEmployee_Signature')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_Employee_Quiz">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Employee_Quiz')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewEmployee_Sign_Legal_Document">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewEmployee_Sign_Legal_Document')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewEmployee_PrintBadge">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewEmployee_PrintBadge')">
                </app-field-wrapper>
              </div>
            </div>
          </div>

          <!-- Colonne 2 -->
          <div class="space-y-0">
            <!-- Returning Employee Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-sitemap mr-2"></i> {{'vues.pointOfService.detail.sections.returningEmployee'|translate}}
              </h4>

              <div class="space-y-3">
                <app-field-wrapper property="dS_ReturningEmployee_Skip_Signature">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_ReturningEmployee_Skip_Signature')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_ReturningEmployee_Sign_Legal_Document_Yearly">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_ReturningEmployee_Sign_Legal_Document_Yearly')">
                </app-field-wrapper>
              </div>
            </div>

            <!-- Returning Contractor Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-sitemap mr-2"></i>
                {{'vues.pointOfService.detail.sections.returningContractor'|translate}}
              </h4>

              <div class="space-y-3">
                <app-field-wrapper property="dS_Contractor_Skip_Signature">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Contractor_Skip_Signature')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_Contractor_Quiz">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Contractor_Quiz')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_Contractor_Enforce_Document_Signature">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Contractor_Enforce_Document_Signature')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_Contractor_Sign_Legal_Document_Days">
                  <input type="number" autocomplete="off" onReady
                    (autoBind)="bindingHandler($event, 'dS_Contractor_Sign_Legal_Document_Days')"
                    class="{{Skin.formInputSmallSize}}"
                    [class.border-red-500]="hasValidationErrors('dS_Contractor_Sign_Legal_Document_Days')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_NewContractor_ShowPhoneNumber">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewContractor_ShowPhoneNumber')">
                </app-field-wrapper>
              </div>
            </div>

            <!-- Menu Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-sitemap mr-2"></i> {{'vues.pointOfService.detail.sections.menu'|translate}}
              </h4>

              <div class="space-y-3">
                <app-field-wrapper property="dS_NewVisitor">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_NewVisitor')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_MultipleVisitors">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_MultipleVisitors')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_Contractor">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Contractor')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_Employee">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Employee')">
                </app-field-wrapper>
                <app-field-wrapper property="feature_Visit">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'feature_Visit')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_WorkspaceReservation">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_WorkspaceReservation')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_Delivery">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Delivery')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_EmployeeOnly">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_EmployeeOnly')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_Employee_QrCodeGenerator">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Employee_QrCodeGenerator')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_FaceRecognition">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_FaceRecognition')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_ShowQrCode">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_ShowQrCode')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_Checkout_Feedbacks">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Checkout_Feedbacks')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_ShowBuzzer">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_ShowBuzzer')">
                </app-field-wrapper>
                <app-field-wrapper property="dS_SleepScreen">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_SleepScreen')">
                </app-field-wrapper>

                <div class="grid grid-cols-2 gap-4 mt-4">
                  <app-field-wrapper property="dS_SleepStartHour">
                    <select class="{{Skin.formInputSmallSize}}" onReady
                      (autoBind)="bindingHandler($event, 'dS_SleepStartHour')"
                      [class.border-red-500]="hasValidationErrors('dS_SleepStartHour')">
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                    </select>
                  </app-field-wrapper>
                  <app-field-wrapper property="dS_SleepEndHour">
                    <select class="{{Skin.formInputSmallSize}}" onReady
                      (autoBind)="bindingHandler($event, 'dS_SleepEndHour')"
                      [class.border-red-500]="hasValidationErrors('dS_SleepEndHour')">
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                    </select>
                  </app-field-wrapper>
                </div>
              </div>
            </div>

            <!-- Workspace Menu Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-sitemap mr-2"></i> {{'vues.pointOfService.detail.sections.workspaceMenu'|translate}}
              </h4>

              <div class="space-y-3">
                <app-field-wrapper property="dS_WRInstance_CovidAlert">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_WRInstance_CovidAlert')">
                </app-field-wrapper>
              </div>
            </div>



          </div>

          <!-- Colonne 3 -->
          <div class="space-y-0">


            <!-- Visitor Policies Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-tasks mr-2"></i> {{'vues.pointOfService.detail.sections.visitorPolicies'|translate}}
                <!-- <button class="text-[#009F9E] ml-2 open-modal" data-modal="modal-visitor-policies">
                    <i class="fas fa-pencil text-xs"></i>
                  </button> -->
                <button (click)="openModal('modal-policy-upload')"
                  class="mt-3 bg-[#009F9E] text-white px-3 py-1.5 hover:bg-[#008a8a] text-xs rounded-[2px]">
                  <i class="fas fa-file-upload mr-1"></i> Upload Policies
                </button>
              </h4>

              <div>
                <label class="block text-xs font-medium text-gray-700 mb-1">
                  {{'Frequency' | translate}} ({{
                  'days' |
                  translate
                  }})
                </label>
                <input class="w-full border border-gray-300 p-2 focus:ring-[#009F9E] focus:border-[#009F9E] text-xs rounded"
                  max="366" min="0" required type="number" onReady
                  (autoBind)="bindingHandler($event, 'policiesFrequency')">
              </div>
            </div>

            <!-- Engagement Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-handshake mr-2"></i> {{'vues.pointOfService.detail.sections.engagements'|translate}}
                <button (click)="openTranslatableModal('engagement')"
                  class="mt-3 bg-[#009F9E] text-white px-3 py-1.5 hover:bg-[#008a8a] text-xs rounded-[2px]">
                  <i class="fas fa-pencil mr-1"></i> {{ 'buttons.edit' | translate }}
                </button>
              </h4>
              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-white">
                    <tr>
                      <th class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider">Title</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    @for (item of getEngagements(); track item.id) {
                    <tr class="border-t border-gray-200">
                      <td class="px-4 py-2 whitespace-nowrap text-xs">{{ item.description || '—' }}</td>
                    </tr>
                    }
                    @if (getEngagements().length === 0) {
                    <tr>
                      <td colspan="2" class="px-4 py-3 text-xs text-gray-400 italic text-center">No engagements yet.</td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Healthy Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-handshake mr-2"></i> {{'vues.pointOfService.detail.sections.healthy'|translate}}
                <button (click)="openTranslatableModal('covid')"
                  class="mt-3 bg-[#009F9E] text-white px-3 py-1.5 hover:bg-[#008a8a] text-xs rounded-[2px]">
                  <i class="fas fa-pencil mr-1"></i> {{ 'buttons.edit' | translate }}
                </button>
              </h4>
              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-white">
                    <tr>
                      <th class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider">Title</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    @for (item of getCovidItems(); track item.id) {
                    <tr class="border-t border-gray-200">
                      <td class="px-4 py-2 whitespace-nowrap text-xs">{{ item.description || '—' }}</td>
                    </tr>
                    }
                    @if (getCovidItems().length === 0) {
                    <tr>
                      <td colspan="2" class="px-4 py-3 text-xs text-gray-400 italic text-center">No healthy items yet.</td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Quiz Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-question-circle mr-2"></i> {{'vues.pointOfService.detail.sections.quizConfig'|translate}}
                <button (click)="openTranslatableModal('quiz')"
                  class="mt-3 bg-[#009F9E] text-white px-3 py-1.5 hover:bg-[#008a8a] text-xs rounded-[2px]">
                  <i class="fas fa-pencil mr-1"></i> {{ 'buttons.edit' | translate }}
                </button>
              </h4>

              <div class="overflow-x-auto mb-4">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-white">
                    <tr>
                      <th class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider">Question</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    @for (item of getQuizItems(); track item.id) {
                    <tr class="border-t border-gray-200">
                      <td class="px-4 py-2 whitespace-nowrap text-xs">{{ item.description || '—' }}</td>
                    </tr>
                    }
                    @if (getQuizItems().length === 0) {
                    <tr>
                      <td colspan="2" class="px-4 py-3 text-xs text-gray-400 italic text-center">No quiz questions yet.</td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>

              <div class="space-y-4">
                <app-field-wrapper property="quiz_NbQuestion" label="Number of Questions">
                  <input
                    class="w-full border border-gray-300 p-2 focus:ring-[#009F9E] focus:border-[#009F9E] text-xs rounded"
                    type="number" onReady (autoBind)="bindingHandler($event, 'quiz_NbQuestion')">
                </app-field-wrapper>

                <app-field-wrapper property="quiz_Random" label="Display Randomly">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'quiz_Random')">
                </app-field-wrapper>

                <app-field-wrapper property="quizFrequency" label="Frequency">
                  <select
                    class="w-full border border-gray-300 p-2 focus:ring-[#009F9E] focus:border-[#009F9E] text-xs rounded"
                    onReady (autoBind)="bindingHandler($event, 'quizFrequency')">
                    <option value="daily">{{'Daily' | translate}}</option>
                    <option value="weekly">{{'Weekly' | translate}}</option>
                    <option value="monthly">{{'Monthly' | translate}}</option>
                    <option value="yearly">{{'Yearly' | translate}}</option>
                  </select>
                </app-field-wrapper>
              </div>
            </div>



            <!-- Buzzer Config Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-bell mr-2"></i> {{'vues.pointOfService.detail.sections.buzzerConfig'|translate}}
                <button (click)="openTranslatableModal('buzzer')"
                  class="mt-3 bg-[#009F9E] text-white px-3 py-1.5 hover:bg-[#008a8a] text-xs rounded-[2px]">
                  <i class="fas fa-pencil mr-1"></i> {{ 'buttons.edit' | translate }}
                </button>
              </h4>
              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-white">
                    <tr>
                      <th class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider">{{'entities.buzzer-config.propreties.subject'|translate}}</th>
                      <th class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider">{{'entities.buzzer-config.propreties.status'|translate}}</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    @for (buzzer of getBuzzerItems(); track buzzer.id) {
                    <tr class="border-t border-gray-200">
                      <td class="px-4 py-2 whitespace-nowrap text-xs">{{ buzzer['subjectTranslations']?.[0]?.['translationValue'] ?? '—' }}</td>
                      <td class="px-4 py-2 whitespace-nowrap">
                        <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full text-white"
                          [class.bg-[#10b981]]="buzzer['status'] === 1"
                          [class.bg-[#f59e0b]]="buzzer['status'] !== 1">
                          {{ buzzer['status'] === 1 ? ('entities.buzzer-status.active'|translate) : ('entities.buzzer-status.inactive'|translate) }}
                        </span>
                      </td>
                    </tr>
                    }
                    @if (getBuzzerItems().length === 0) {
                    <tr>
                      <td colspan="2" class="px-4 py-3 text-xs text-gray-400 italic text-center">No buzzers yet.</td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>



            <!-- Evacuation Alert Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-running mr-2"></i> {{'vues.pointOfService.detail.sections.evacuationAlert'|translate}}
                <button (click)="openTranslatableModal('firealert')"
                  class="mt-3 bg-[#009F9E] text-white px-3 py-1.5 hover:bg-[#008a8a] text-xs rounded-[2px]">
                  <i class="fas fa-pencil mr-1"></i> {{ 'buttons.edit' | translate }}
                </button>
              </h4>

              <div class="mb-4">
                <app-field-wrapper property="dS_FireAlert">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_FireAlert')">
                </app-field-wrapper>
              </div>

              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr class="border-t border-gray-200">
                      <td class="px-4 py-2 whitespace-nowrap text-xs font-medium">{{'vues.translatableEntityModal.fireAlert.emailSubject'|translate}}</td>
                      <td class="px-4 py-2 text-xs">{{ getFireAlertText(1) }}</td>
                    </tr>
                    <tr class="border-t border-gray-200">
                      <td class="px-4 py-2 whitespace-nowrap text-xs font-medium">{{'vues.translatableEntityModal.fireAlert.emailBody'|translate}}</td>
                      <td class="px-4 py-2 text-xs">{{ getFireAlertText(2) }}</td>
                    </tr>
                    <tr class="border-t border-gray-200">
                      <td class="px-4 py-2 whitespace-nowrap text-xs font-medium">{{'vues.translatableEntityModal.fireAlert.sms'|translate}}</td>
                      <td class="px-4 py-2 text-xs">{{ getFireAlertText(5) }}</td>
                    </tr>
                    <tr class="border-t border-gray-200">
                      <td class="px-4 py-2 whitespace-nowrap text-xs font-medium">{{'vues.translatableEntityModal.fireAlert.teams'|translate}}</td>
                      <td class="px-4 py-2 text-xs">{{ getFireAlertText(6) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 2: Trucker Settings -->
      <div class="mb-0">
        <h2 class="text-base font-semibold text-gray-700 mb-0 border-b-2 border-black pb-2 mb-4">
          <i class="fas fa-truck mr-2"></i>{{'vues.pointOfService.detail.sections.truckerSettings'|translate}}
        </h2>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-0">
          <!-- Colonne 1 -->
          <div class="space-y-0">
            <!-- Trucker Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-truck mr-2"></i> {{'vues.pointOfService.detail.sections.trucker'|translate}}
              </h4>

              <div class="mb-4">
                <app-field-wrapper property="dS_Trucker_AutomaticAssignDock">
                  <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Trucker_AutomaticAssignDock')">
                </app-field-wrapper>
              </div>

              <div class="mb-4">
                <div class="flex">
                  <input type="text" placeholder="Search"
                    class="w-full border border-gray-300 p-2 text-xs rounded-l-[20px] border-r-0">
                  <button class="bg-white border border-gray-300 p-2 text-xs rounded-r-[20px] border-l-0">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>

              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-white">
                    <tr>
                      <th class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider">Select</th>
                      <th class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider">Full Name</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr class="border-t border-gray-200">
                      <td class="px-4 py-2 whitespace-nowrap">
                        <input type="checkbox" class="w-3.5 h-3.5">
                      </td>
                      <td class="px-4 py-2 whitespace-nowrap text-xs">James Wilson</td>
                    </tr>
                    <tr class="border-t border-gray-200">
                      <td class="px-4 py-2 whitespace-nowrap">
                        <input type="checkbox" class="w-3.5 h-3.5">
                      </td>
                      <td class="px-4 py-2 whitespace-nowrap text-xs">Emily Davis</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="flex justify-between items-center mt-4">

                <div class="flex">
                  <button class="px-3 py-1 border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 text-xs rounded-none">
                    <i class="fas fa-angle-double-left"></i>
                  </button>
                  <button class="px-3 py-1 border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 text-xs rounded-none">
                    <i class="fas fa-angle-left"></i>
                  </button>
                  <button class="px-3 py-1 border border-gray-300 bg-[#009F9E] text-white text-xs rounded-none">1</button>
                  <button class="px-3 py-1 border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 text-xs rounded-none">
                    2
                  </button>
                  <button class="px-3 py-1 border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 text-xs rounded-none">
                    <i class="fas fa-angle-right"></i>
                  </button>
                  <button class="px-3 py-1 border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 text-xs rounded-none">
                    <i class="fas fa-angle-double-right"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- QR Code Trucker Settings Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-qrcode mr-2"></i> {{'vues.pointOfService.detail.sections.qRCodeSettings'|translate}}
                <button class="text-[#009F9E] ml-2 open-modal" data-modal="modal-qrcodes-trucker">
                  <i class="fas fa-pencil text-xs"></i>
                </button>
              </h4>


            </div>

            <!-- Trucker Policies Card -->
            <div class="bg-white shadow-none p-6 border-b border-gray-200">
              <h4 class="text-base font-medium text-gray-800 mb-4 border-b-2 border-black pb-2">
                <i class="fas fa-tasks mr-2"></i> {{'vues.pointOfService.detail.sections.truckerPolicies'|translate}}
                <button class="text-[#009F9E] ml-2 open-modal" data-modal="modal-trucker-policies">
                  <i class="fas fa-pencil text-xs"></i>
                </button>
              </h4>

              <app-field-wrapper property="truckerPoliciesFrequency">
                <input
                  class="w-full border border-gray-300 p-2 focus:ring-[#009F9E] focus:border-[#009F9E] text-xs rounded"
                  max="366" min="0" required type="number" onReady
                  (autoBind)="bindingHandler($event, 'truckerPoliciesFrequency')">
              </app-field-wrapper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




  <!-- Modals -->
  <!-- Qr Code Visitor download -->
  <div
    id="modal-qrcodes-visitor"
    class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 hidden">
    <div
      class="bg-white p-8 rounded-lg shadow-lg w-1/3 max-h-[80vh] flex flex-col">
      <h2 class="text-xl font-bold mb-4">
        {{ 'entities.pointOfService.propreties.dS_ShowQrCode' | translate }}
      </h2>

      <div class="space-y-4 overflow-y-auto">

        <!-- CHECKBOXES -->
        <div class="space-y-3">
          <app-field-wrapper property="dS_Visitor_QrCodeScanner">
            <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Visitor_QrCodeScanner')" />
          </app-field-wrapper>

          <app-field-wrapper property="dS_Employee_QrCodeScanner">
            <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Employee_QrCodeScanner')" />
          </app-field-wrapper>

          <app-field-wrapper property="dS_Contractor_QrCodeScanner">
            <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Contractor_QrCodeScanner')" />
          </app-field-wrapper>
        </div>

        <!-- QR HOME -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div class="flex flex-col items-center">
            <a
              class="text-blue-600 hover:underline cursor-pointer"
              href="{{baseUrl}}/home"
              target="_blank">
              {{ 'entities.pointOfService.propreties.qrcodesHome' | translate }}
            </a>

            <div
              #qrCodeHomeContainer
              id="qrCodeHomeContainer"
              class="qrCodeHomeContainer qr-preview"></div>

            <button
              class="bg-[#009F9E] text-white px-4 py-2 hover:bg-[#008a8a] flex items-center text-xs rounded-[2px]"
              (click)="downloadHome()">
              <i class="fas fa-qrcode mr-2"></i>
              {{ 'vues.pointOfService.detail.buttons.downloadQRCode' | translate }}
            </button>
          </div>
        </div>


      </div>

      <!-- FOOTER -->
      <div class="mt-6 flex justify-end">
        <button
          (click)="hideModal('modal-qrcodes-visitor')"
          class="{{ Skin.btnAlert }} uppercase py-2 px-4">
          {{ 'buttons.close' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Qr Code Trucker download -->
  <div id="modal-qrcodes-trucker" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 hidden">
    <div class="bg-white p-8 rounded-lg shadow-lg w-1/3 max-h-[80vh] flex flex-col">
      <h2 class="text-xl font-bold mb-4">{{ 'entities.pointOfService.propreties.dS_ShowQrCode' |translate }}</h2>
      <div class="space-y-4 overflow-y-auto">
        <div class="space-y-3">
          <app-field-wrapper property="dS_Trucker_QrCodeScanner">
            <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'dS_Trucker_QrCodeScanner')">
          </app-field-wrapper>
        </div>
        <!-- QR HOME -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div class="flex flex-col items-center">
            <a
              class="text-blue-600 hover:underline cursor-pointer"
              href="{{baseUrl}}/home"
              target="_blank">
              {{ 'entities.pointOfService.propreties.qrcodesHome' | translate }}
            </a>

            <div
              #qrCodeHomeContainer
              id="qrCodeHomeContainer"
              class="qrCodeHomeContainer qr-preview"></div>

            <button
              class="bg-[#009F9E] text-white px-4 py-2 hover:bg-[#008a8a] flex items-center text-xs rounded-[2px]"
              (click)="downloadHome()">
              <i class="fas fa-qrcode mr-2"></i>
              {{ 'vues.pointOfService.detail.buttons.downloadQRCode' | translate }}
            </button>
          </div>
        </div>

        <!-- ACCORDÉON : DETAIL QR CODE -->
        <details class="border rounded-md">

          <summary
            class="cursor-pointer list-none flex justify-between items-center px-4 py-3 bg-gray-100 hover:bg-gray-200 text-sm font-semibold">
            <span>Detail QR Code</span>
            <span class="transition-transform duration-300 details-open:rotate-180">
              <i class="fas fa-chevron-down"></i>
            </span>
          </summary>

          <div class="p-4">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

              <!-- TRUCKER CHECK-IN -->
              <div class="flex flex-col items-center">
                <a
                  class="text-blue-600 hover:underline cursor-pointer"
                  href="{{baseUrl}}/trucker-checkin"
                  target="_blank">
                  {{ 'entities.pointOfService.propreties.qrcodesTruckerCheckin' | translate }}
                </a>

                <div
                  #qrCodeTruckerCheckinContainer
                  id="qrCodeTruckerCheckinContainer"
                  class="qr-preview"></div>

                <button
                  class="bg-[#009F9E] text-white px-4 py-2 hover:bg-[#008a8a] flex items-center text-xs rounded-[2px]"
                  (click)="downloadTruckerCheckin()">
                  <i class="fas fa-qrcode mr-2"></i>
                  {{ 'vues.pointOfService.detail.buttons.downloadQRCode' | translate }}
                </button>
              </div>

              <!-- TRUCKER CHECK-OUT -->
              <div class="flex flex-col items-center">
                <a
                  class="text-blue-600 hover:underline cursor-pointer"
                  href="{{baseUrl}}/trucker-checkout"
                  target="_blank">
                  {{ 'entities.pointOfService.propreties.qrcodesTruckerCheckout' | translate }}
                </a>

                <div
                  #qrCodeTruckerCheckoutContainer
                  id="qrCodeTruckerCheckoutContainer"
                  class="qr-preview"></div>

                <button
                  class="bg-[#009F9E] text-white px-4 py-2 hover:bg-[#008a8a] flex items-center text-xs rounded-[2px]"
                  (click)="downloadTruckerCheckout()">
                  <i class="fas fa-qrcode mr-2"></i>
                  {{ 'vues.pointOfService.detail.buttons.downloadQRCode' | translate }}
                </button>
              </div>

            </div>
          </div>

        </details>

      </div>
      <div class="mt-6 flex justify-end">
        <button (click)="hideModal('modal-qrcodes-trucker')" class="{{Skin.btnAlert}} uppercase py-2 px-4">
          {{ 'buttons.close' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal for Email Settings -->
  <div id="modal-email" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 hidden">
    <div class="bg-white p-8 rounded-lg shadow-lg w-1/3 max-h-[80vh] flex flex-col">
      <h2 class="text-xl font-bold mb-4">{{'vues.pointOfService.detail.sections.emailSettings'|translate}}</h2>
      <div class="space-y-4 overflow-y-auto">
        <app-field-wrapper property="emailSettingFrom">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'emailSettingFrom')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('emailSettingFrom')">
        </app-field-wrapper>
      </div>
      <div class="mt-6 flex justify-end">
        <button (click)="hideModal('modal-email')" class="{{Skin.btnAlert}} uppercase py-2 px-4">
          {{ 'buttons.close' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal for Printer Settings -->
  <div id="modal-printer" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 hidden">
    <div class="bg-white p-8 rounded-lg shadow-lg w-2/3 max-h-[80vh] flex flex-col">
      <h2 class="text-xl font-bold mb-4">{{'vues.pointOfService.detail.sections.printerSettings'|translate}}</h2>
      <div class="space-y-4 overflow-y-auto">
        <app-field-wrapper property="urlAddressPrinter">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'urlAddressPrinter')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('urlAddressPrinter')">
        </app-field-wrapper>
        <app-field-wrapper property="printBadge">
          <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'printBadge')">
        </app-field-wrapper>
        <app-field-wrapper property="printerBrightness">
          <input type="number" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'printerBrightness')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('printerBrightness')">
        </app-field-wrapper>
        <app-field-wrapper property="printerLabelType">
          <input type="number" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'printerLabelType')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('printerLabelType')">
        </app-field-wrapper>
        <app-field-wrapper property="printerLabelSize">
          <input type="number" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'printerLabelSize')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('printerLabelSize')">
        </app-field-wrapper>
        <app-field-wrapper property="printCompany">
          <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'printCompany')">
        </app-field-wrapper>
        <app-field-wrapper property="printName">
          <input class="w-5 h-5" type="checkbox" onReady (autoBind)="bindingHandler($event, 'printName')">
        </app-field-wrapper>
        <!-- Badge Template Editor -->
        <div class="border-t border-gray-200 pt-4 mt-4">
          <h4 class="text-sm font-semibold text-gray-700 mb-2">
            <i class="fas fa-id-badge mr-1"></i> Badge Template
          </h4>
          <app-html-editor
            [template]="editingEntity()?.badgeTemplate ?? ''"
            (templateChange)="editingEntity()!.badgeTemplate = $event">
          </app-html-editor>
        </div>
      </div>
      <div class="mt-6 flex justify-end">
        <button (click)="hideModal('modal-printer')" class="{{Skin.btnAlert}} uppercase py-2 px-4">
          {{ 'buttons.close' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal for Wifi Connection -->
  <div id="modal-wifi" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 hidden">
    <div class="bg-white p-8 rounded-lg shadow-lg w-1/3 max-h-[80vh] flex flex-col">
      <h2 class="text-xl font-bold mb-4">{{'vues.pointOfService.detail.sections.wifiConnection'|translate}}</h2>
      <div class="space-y-4 overflow-y-auto">
        <app-field-wrapper property="wIFI_Name">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'wIFI_Name')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('wIFI_Name')">
        </app-field-wrapper>
        <app-field-wrapper property="wIFI_Account">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'wIFI_Account')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('wIFI_Account')">
        </app-field-wrapper>
        <app-field-wrapper property="wIFI_Password">
          <input type="password" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'wIFI_Password')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('wIFI_Password')">
        </app-field-wrapper>
      </div>
      <div class="mt-6 flex justify-end">
        <button (click)="hideModal('modal-wifi')" class="{{Skin.btnAlert}} uppercase py-2 px-4">
          {{ 'buttons.close' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal for Address -->
  <div id="modal-address" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 hidden">
    <div class="bg-white p-8 rounded-lg shadow-lg w-1/3 max-h-[80vh] flex flex-col">
      <h2 class="text-xl font-bold mb-4">{{'vues.pointOfService.detail.sections.address'|translate}}</h2>
      <div class="space-y-4 overflow-y-auto">
        <app-field-wrapper property="civicNumber" label="civic-number">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'civicNumber')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('civicNumber')">
        </app-field-wrapper>
        <app-field-wrapper property="street" label="street">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'street')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('street')">
        </app-field-wrapper>
        <app-field-wrapper property="officeNumber" label="office-number">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'officeNumber')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('officeNumber')">
        </app-field-wrapper>
        <app-field-wrapper property="city" label="city">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'city')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('city')">
        </app-field-wrapper>
        <app-field-wrapper property="state" label="state">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'state')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('state')">
        </app-field-wrapper>
        <app-field-wrapper property="country" label="country">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'country')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('country')">
        </app-field-wrapper>
        <app-field-wrapper property="postalCode" label="postal-code">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'postalCode')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('postalCode')">
        </app-field-wrapper>
      </div>
      <div class="mt-6 flex justify-end">
        <button (click)="hideModal('modal-address')" class="{{Skin.btnAlert}} uppercase py-2 px-4">
          {{ 'buttons.close' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal for Integration -->
  <div id="modal-integration"
    class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 hidden">
    <div class="bg-white p-8 rounded-lg shadow-lg w-1/3 max-h-[80vh] flex flex-col">
      <h2 class="text-xl font-bold mb-4">{{'vues.pointOfService.detail.sections.integration'|translate}}</h2>
      <div class="space-y-4 overflow-y-auto">
        <app-field-wrapper property="slackToken">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'slackToken')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('slackToken')">
        </app-field-wrapper>
        <app-field-wrapper property="teamsBotId">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'teamsBotId')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('teamsBotId')">
        </app-field-wrapper>
        <app-field-wrapper property="teamsBotSecret">
          <input type="password" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'teamsBotSecret')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('teamsBotSecret')">
        </app-field-wrapper>
        <app-field-wrapper property="teamsServiceUrl">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'teamsServiceUrl')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('teamsServiceUrl')">
        </app-field-wrapper>
        <app-field-wrapper property="teamsTenantId">
          <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'teamsTenantId')"
            class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('teamsTenantId')">
        </app-field-wrapper>
      </div>
      <div class="mt-6 flex justify-end">
        <button (click)="hideModal('modal-integration')" class="{{Skin.btnAlert}} uppercase py-2 px-4">
          {{ 'buttons.close' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal for Visitor Policies -->
  <!-- Modal for Policy Files Upload -->
  <div id="modal-policy-upload"
    class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 hidden">
    <div class="bg-white p-6 rounded-lg shadow-lg w-2/3 max-h-[85vh] flex flex-col">
      <h2 class="text-lg font-bold mb-4">
        <i class="fas fa-file-upload mr-2"></i> Policy Files
      </h2>

      <!-- Tabs -->
      <div class="flex border-b border-gray-200 mb-4">
        <button (click)="activePolicyTab.set('html')"
          class="px-4 py-2 text-xs font-medium transition-colors"
          [class.border-b-2]="activePolicyTab() === 'html'"
          [class.border-[#009F9E]]="activePolicyTab() === 'html'"
          [class.text-[#009F9E]]="activePolicyTab() === 'html'"
          [class.text-gray-500]="activePolicyTab() !== 'html'">
          <i class="fas fa-file-code mr-1"></i> HTML Template
        </button>
        @for (lang of languageLookup(); track lang.id) {
        <button (click)="activePolicyTab.set(lang.id)"
          class="px-4 py-2 text-xs font-medium transition-colors"
          [class.border-b-2]="activePolicyTab() === lang.id"
          [class.border-[#009F9E]]="activePolicyTab() === lang.id"
          [class.text-[#009F9E]]="activePolicyTab() === lang.id"
          [class.text-gray-500]="activePolicyTab() !== lang.id">
          <i class="fas fa-file-pdf mr-1"></i> PDF — {{ lang.value }}
        </button>
        }
      </div>

      <!-- Tab Content -->
      <div class="flex-1 overflow-y-auto">
        <!-- ==================== HTML Tab (remplace RDLC) ==================== -->
        @if (activePolicyTab() === 'html') {
        <div class="space-y-3">

          <!-- Existing HTML template versions -->
          @if (getVisitorHtmlPolicies().length > 0) {
          <table class="min-w-full divide-y divide-gray-200 text-xs">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-3 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Version</th>
                <th class="px-3 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">File</th>
                <th class="px-3 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th class="px-3 py-2 text-right font-medium text-gray-500 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              @for (policy of getVisitorHtmlPolicies(); track policy.id) {
              <tr>
                <td class="px-3 py-2 whitespace-nowrap font-medium">v{{ policy.numero }}</td>
                <td class="px-3 py-2 whitespace-nowrap">
                  <i class="fas fa-file-code mr-1 text-indigo-500"></i>
                  {{ policy.file?.fileName || policy.description || '—' }}
                </td>
                <td class="px-3 py-2 whitespace-nowrap">
                  @if (policy.isLastVersion) {
                  <span class="bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-[10px] font-semibold">Current</span>
                  } @else {
                  <span class="bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full text-[10px]">Old</span>
                  }
                </td>
                <td class="px-3 py-2 whitespace-nowrap text-right">
                  <button (click)="deletePolicy(policy.id)" class="text-red-500 hover:text-red-700" title="Delete">
                    <i class="fas fa-trash text-xs"></i>
                  </button>
                </td>
              </tr>
              }
            </tbody>
          </table>
          } @else {
          <p class="text-xs text-gray-400 italic py-2">No HTML template versions yet.</p>
          }

          <!-- Pending HTML files -->
          @for (pending of getPendingFiles(3); track pending.id) {
          <div class="flex items-center justify-between bg-amber-50 border border-amber-200 rounded p-2 text-xs">
            <span>
              <i class="fas fa-clock mr-1 text-amber-500"></i>
              <span class="font-medium">Pending:</span> {{ pending.file.name }}
            </span>
            <button (click)="removePendingFile(pending.id)" class="text-red-500 hover:text-red-700">
              <i class="fas fa-times"></i>
            </button>
          </div>
          }

          <!-- Upload new HTML template -->
          @if (isEditMode()) {
          <div class="mt-2">
            <label class="inline-flex items-center px-3 py-1.5 bg-[#009F9E] text-white text-xs rounded-[2px] cursor-pointer hover:bg-[#008a8a]">
              <i class="fas fa-plus mr-1"></i> Add new HTML version
              <input type="file" accept=".html,.htm" class="hidden"
                (change)="onPolicyFileSelected($event, 3)">
            </label>
          </div>
          }

        </div>
        }

        <!-- ==================== PDF Language Tabs ==================== -->
        @for (lang of languageLookup(); track lang.id) {
        @if (activePolicyTab() === lang.id) {
        <div class="space-y-3">

          <!-- Existing PDF versions for this language -->
          @if (getVisitorPdfPoliciesByLanguage(lang.value).length > 0) {
          <table class="min-w-full divide-y divide-gray-200 text-xs">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-3 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Version</th>
                <th class="px-3 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">File</th>
                <th class="px-3 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th class="px-3 py-2 text-right font-medium text-gray-500 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              @for (policy of getVisitorPdfPoliciesByLanguage(lang.value); track policy.id) {
              <tr>
                <td class="px-3 py-2 whitespace-nowrap font-medium">v{{ policy.numero }}</td>
                <td class="px-3 py-2 whitespace-nowrap">
                  <i class="fas fa-file-pdf mr-1 text-red-500"></i>
                  {{ policy.file?.fileName || policy.description || '—' }}
                </td>
                <td class="px-3 py-2 whitespace-nowrap">
                  @if (policy.isLastVersion) {
                  <span class="bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-[10px] font-semibold">
                    Current
                  </span>
                  } @else {
                  <span class="bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full text-[10px]">
                    Old
                  </span>
                  }
                </td>
                <td class="px-3 py-2 whitespace-nowrap text-right">
                  <button (click)="deletePolicy(policy.id)"
                    class="text-red-500 hover:text-red-700" title="Delete">
                    <i class="fas fa-trash text-xs"></i>
                  </button>
                </td>
              </tr>
              }
            </tbody>
          </table>
          } @else {
          <p class="text-xs text-gray-400 italic py-2">No PDF versions for {{ lang.value }} yet.</p>
          }

          <!-- Pending PDF files for this language -->
          @for (pending of getPendingFiles(1, +lang.id); track pending.id) {
          <div class="flex items-center justify-between bg-amber-50 border border-amber-200 rounded p-2 text-xs">
            <span>
              <i class="fas fa-clock mr-1 text-amber-500"></i>
              <span class="font-medium">Pending:</span> {{ pending.file.name }}
            </span>
            <button (click)="removePendingFile(pending.id)" class="text-red-500 hover:text-red-700">
              <i class="fas fa-times"></i>
            </button>
          </div>
          }

          <!-- Upload new PDF for this language -->
          @if (isEditMode()) {
          <div class="mt-2">
            <label
              class="inline-flex items-center px-3 py-1.5 bg-[#009F9E] text-white text-xs rounded-[2px] cursor-pointer hover:bg-[#008a8a]">
              <i class="fas fa-plus mr-1"></i> Add new PDF version ({{ lang.value }})
              <input type="file" accept=".pdf" class="hidden"
                (change)="onPolicyFileSelected($event, 1, +lang.id)">
            </label>
            <span class="ml-2 text-[10px] text-gray-400">File must end with _{{ lang.value }}.pdf</span>
          </div>
          }

        </div>
        }
        }

      </div>

      <!-- Footer -->
      <div class="mt-4 pt-3 border-t border-gray-200 flex justify-end">
        <button (click)="hideModal('modal-policy-upload')" class="{{Skin.btnAlert}} uppercase py-2 px-4">
          {{ 'buttons.close' | translate }}
        </button>
      </div>
    </div>
  </div>


  <!-- Modal for Trucker Policies -->
  <div id="modal-trucker-policies"
    class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 hidden">
    <div class="bg-white p-8 rounded-lg shadow-lg w-1/3 max-h-[80vh] flex flex-col">
      <h2 class="text-xl font-bold mb-4">Trucker Policies</h2>
      <div class="space-y-4 overflow-y-auto">
        <app-field-wrapper property="truckerPoliciesFrequency">
          <input type="number" autocomplete="off" onReady
            (autoBind)="bindingHandler($event, 'truckerPoliciesFrequency')" class="{{Skin.formInputSmallSize}}"
            [class.border-red-500]="hasValidationErrors('truckerPoliciesFrequency')">
        </app-field-wrapper>
      </div>
      <div class="mt-6 flex justify-end">
        <button (click)="hideModal('modal-trucker-policies')" class="{{Skin.btnAlert}} uppercase py-2 px-4">
          {{ 'buttons.close' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== Translatable Entity Modals ==================== -->

  @for (modalType of ['engagement', 'quiz', 'covid', 'buzzer', 'firealert']; track modalType) {
  <app-translatable-entity-modal
    [config]="getTranslatableConfig(modalType)"
    [visible]="activeTranslatableModal() === modalType"
    [languages]="languageLookup()"
    [defaultLanguageId]="editingEntity()?.fK_i18nLanguage || 0"
    [isEditMode]="isEditMode()"
    [Skin]="Skin"
    [items]="getTranslatableItems(modalType)"
    (close)="closeTranslatableModal()"
    (saveAll)="onTranslatableSave(modalType, $event)"
    (deleteItem)="onTranslatableItemDelete($event)">
  </app-translatable-entity-modal>
  }


  <!-- Boutons en bas du formulaire - TOUJOURS VISIBLES -->
  <div class="bg-stone-50 min-w-full flex space-x-1  pt-2 border-t border-gray-200 mt-1 pb-2 sticky bottom-0 z-10">
    <button type="button" (click)="saveItem()" [disabled]="!isFormValid()"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save' | translate }}
    </button>

    <button type="button" (click)="saveAndCloseItem()" [disabled]="!isFormValid()"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save-and-close' | translate }}
    </button>

    <button (click)="cancelEdit()" class="{{Skin.btnAlert}} uppercase py-2 px-2">
      <i class="fas fa-times mr-2"></i>
      {{ 'buttons.cancel' | translate }}
    </button>
  </div>
</div>

}
}